module.exports = __webpack_public_path__ + "img/totalmeetings10.ce82e2ac.png";